















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import LibraryAddMedia from '@/web/views/admin/media-library/LibraryAddMedia.vue';
import MediaItemCard from '@/web/components/media-library/MediaItemCard.vue';
import { errorToMessage } from '@/core/utils/errors';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

interface LocalState {
  draggableDelay: number;
  contentResponse: PaginatedResponse<ContentResponse>;
  content: ContentResponse[];
  contentExist: boolean;
  loading: boolean;
}

export default Vue.extend({
  name: 'ProductContent',
  mixins: [TeacherPermissionsMixin],
  components: {
    MediaItemCard,
  },
  data(): LocalState {
    return {
      contentResponse: [],
      content: [],
      contentExist: false,
      loading: false,
    };
  },
  async mounted() {
    this.contentExist = await this.getContent();
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
    }),
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
  },
  methods: {
    async getContent(): Promise<boolean> {
      this.loading = true;
      this.contentResponse = await this.$store.dispatch(
        'product/getProductContent',
        {
          productId: this.productId,
        }
      );
      if (this.contentResponse) {
        this.content = [...this.contentResponse.results];
        this.loading = false;
        return this.content.length > 0;
      }
      this.loading = false;
      return false;
    },
    async openMedia(media) {
      // Open media for editing
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData: media,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async () => {
            this.getContent();
          },
        }
      );
    },
    async openNewMedia(medaiData) {
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async media => {
            await this.$store.dispatch('product/createProductContent', {
              productId: this.productId,
              data: {
                content: [media.id],
              },
            });
            await this.getContent();
          },
        }
      );
    },
    async showAddMediaForm(): Promise<void> {
      this.$modal.show(
        MediaFormModal,
        {
          showSelectMedia: true,
          showEditMedia: false,
          showEmbedHtml: false,
          videoUploadAllowed: this.videoUploadAllowed,
          multiSelect: false,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'media-selected': async (content: any) => {
            await this.$store.dispatch('product/createProductContent', {
              productId: this.productId,
              data: {
                content: content.map(c => c.id),
              },
            });
            this.contentExist = await this.getContent();
          },
          'media-added': medaiData => {
            this.openNewMedia(medaiData);
          },
        }
      );
    },
    async removeContent(id): Promise<void> {
      await this.$store.dispatch('product/deleteProductContent', {
        productId: this.productId,
        contentId: id,
      });
      this.contentExist = await this.getContent();
    },
  },
});
